import React from 'react';
import { Cushion, Typography, MaxWidth } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const NoResults = () => (
  <Cushion all="large" component="div">
    <MaxWidth component="div" maxWidth={260} center>
      <Cushion bottom="medium">
        <Typography preset="subtitle--large" align="center" component="div">
          <Trans i18nKey="teams:no_match_report_results">
            Sorry, there are no match reports to show
          </Trans>
        </Typography>
      </Cushion>
      <Cushion bottom="medium">
        <Typography preset="body--small" align="center" color="dovegrey" component="div">
          <Trans i18nKey="teams:no_match_report_results_description">
            Looks like there isn’t any recent match reports
          </Trans>
        </Typography>
      </Cushion>
    </MaxWidth>
  </Cushion>
);

export default NoResults;
